module.exports = __webpack_public_path__ + "static/media/fortalezas_lines.befb67cb.png";